module.exports = __webpack_public_path__ + "img/gap-fill-1.d765eada.png";